module.exports = __webpack_public_path__ + "static/img/gantanhao.b480a8e8.svg";